import { useEffect } from 'react'

const useAnalytics = ({ location }) => {
  useEffect(() => {
    window.ga('send', 'pageview', `${location.pathname}`) // eslint-disable-line no-undef
  }, [location.pathname])
}

export default useAnalytics
